export enum InitiatePaymentStates {
  INITIATING,
  INITIATING_FAILED,
  INVALID_URL,
}
